module.exports = __webpack_public_path__ + "static/Gotham-Book-989aaeecf2230bbf903db139ceea7ae8.woff2";